'use strict';

angular.module('mobile-apps')
  .factory('FileMain', [
    'EntryMain',
    'CacheDataLoad',
    '$q',
    function (
      EntryMain,
      CacheDataLoad,
      $q
    ) {

      var factory = {};


      /**
       * Returns the files and its entries for the given combination of app, group and language
       */
      factory.getFiles = function (mobileAppId, groupId, languageId, forceRefresh) {
        if (!EntryMain.defaultGroup) {
          return $q.when([]);
        }

        var me = this;

        // Function which loads not cached data from database
        // var getModelData = function (tagId, callback) {
        var getModelData = (function (mobileAppId, groupId, languageId) {
          return function (ignoreString, callback) {
            if (!groupId) {
              // If not group id is set the default group of the app gets used
              groupId = EntryMain.defaultGroup._id;
            }

            var mobileApp = EntryMain.mobileApps[mobileAppId];
            var baseLanguageId = mobileApp._baseLanguage._id;

            // Define in which languages and order it should check for src file name
            var checkLanguages = [languageId];
            if (languageId !== baseLanguageId) {
              checkLanguages.push(baseLanguageId);
            }

            var entry, checkLanguage, key, i;
            var returnFiles = {};
            var keysFound = [];
            var entriesByLanguage = EntryMain.groupLanguageEntryMap[groupId];

            if (!entriesByLanguage) {
              return callback(null, {
                files: returnFiles
              });
            }

            for (i = 0; i < checkLanguages.length; i++) {
              checkLanguage = checkLanguages[i];

              if (!entriesByLanguage.hasOwnProperty(checkLanguages[i])) {
                // If there is no entry for the value then it did not get loaded yet. So simply
                // skip it. This code will get executed again after the data is available by an
                // event and then it can be loaded correctly.
                continue;
              }

              for (key in entriesByLanguage[checkLanguage].values) {
                entry = entriesByLanguage[checkLanguages[i]].values[key];
                if (entry.src) {
                  if (keysFound.indexOf(key) !== -1) {
                    // Key already has a src from an earlier run so ignore the data of the
                    // current one as it has a lower priority because languages are sorted
                    // by highest priority one first.
                    continue;
                  }
                  if (!returnFiles.hasOwnProperty(entry.src)) {
                    returnFiles[entry.src] = [];
                  }
                  returnFiles[entry.src].push(key);
                  keysFound.push(key);
                }
              }
            }

            return callback(null, {
              files: returnFiles
            });

          };
        }(mobileAppId, groupId, languageId));

        // Get data from Cache or Database depending on if data is
        // already available and if forceRefresh is set
        return CacheDataLoad.getData(getModelData, 'fileEntries', groupId + ':' + languageId, forceRefresh);
      };


      return factory;
    }
  ]);
